// extracted by mini-css-extract-plugin
export default {"root":"styles_root__0cr-i","topBar":"styles_topBar__iIUdi","menuBar":"styles_menuBar__aokpU"};